import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { Calendar, X, RefreshCw } from 'lucide-react';
import 'react-datepicker/dist/react-datepicker.css';

interface FilterBarProps {
  users: any[];
  types: any[];
  selectedUser: any;
  selectedType: any;
  startDate: Date | null;
  endDate: Date | null;
  onUserChange: (user: any) => void;
  onTypeChange: (type: any) => void;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  onClearFilters: () => void;
  onRefresh: () => void;
  isRefreshing?: boolean;
}

const FilterBar: React.FC<FilterBarProps> = ({
  users,
  types,
  selectedUser,
  selectedType,
  startDate,
  endDate,
  onUserChange,
  onTypeChange,
  onStartDateChange,
  onEndDateChange,
  onClearFilters,
  onRefresh,
  isRefreshing = false,
}) => {
  const hasActiveFilters = selectedUser || selectedType || startDate || endDate;

  return (
    <div className="card card-custom gutter-b">
      <div className="card-body p-6">
        <div className="d-flex flex-wrap gap-4 align-items-end">
          <div className="flex-grow-1" style={{ minWidth: '200px', maxWidth: '250px' }}>
            <label className="form-label fw-semibold fs-7 text-gray-600 mb-2">
              Usuário
            </label>
            <Select
              value={selectedUser}
              placeholder="Todos os usuários"
              options={users.map((u: any) => ({ value: u.id_user, label: u.name }))}
              onChange={onUserChange}
              isClearable
              className="react-select-styled"
              classNamePrefix="react-select"
            />
          </div>

          <div className="flex-grow-1" style={{ minWidth: '200px', maxWidth: '250px' }}>
            <label className="form-label fw-semibold fs-7 text-gray-600 mb-2">Tipo</label>
            <Select
              value={selectedType}
              placeholder="Todos os tipos"
              options={types.map((t: any) => ({ value: t.id_log_type, label: t.name }))}
              onChange={onTypeChange}
              isClearable
              className="react-select-styled"
              classNamePrefix="react-select"
            />
          </div>

          <div className="flex-grow-1" style={{ minWidth: '180px', maxWidth: '200px' }}>
            <label className="form-label fw-semibold fs-7 text-gray-600 mb-2">
              Data Inicial
            </label>
            <div className="position-relative">
              <DatePicker
                selected={startDate}
                onChange={onStartDateChange}
                dateFormat="dd/MM/yyyy"
                placeholderText="Selecionar data"
                className="form-control form-control-solid"
                isClearable
              />
              
            </div>
          </div>

          <div className="flex-grow-1" style={{ minWidth: '180px', maxWidth: '200px' }}>
            <label className="form-label fw-semibold fs-7 text-gray-600 mb-2">
              Data Final
            </label>
            <div className="position-relative">
              <DatePicker
                selected={endDate}
                onChange={onEndDateChange}
                dateFormat="dd/MM/yyyy"
                placeholderText="Selecionar data"
                className="form-control form-control-solid"
                isClearable
                minDate={startDate || undefined}
              />
              
            </div>
          </div>

          <div className="d-flex gap-2">
            {hasActiveFilters && (
              <button
                className="btn btn-light-danger btn-sm d-flex align-items-center gap-2"
                onClick={onClearFilters}
                title="Limpar filtros"
              >
                <X size={16} />
                Limpar
              </button>
            )}
            <button
              className="btn btn-light-primary btn-sm d-flex align-items-center gap-2"
              onClick={onRefresh}
              disabled={isRefreshing}
              title="Atualizar dados"
            >
              <RefreshCw
                size={16}
                className={isRefreshing ? 'spinner-border spinner-border-sm' : ''}
              />
              {isRefreshing ? 'Atualizando...' : 'Atualizar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
